import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { createForecastTrackingMatrix } from "../../utils/forecast_tracking_matrix";

// OOFOS three-forecast view: same layout and title as Forecast Tracking
// (the title string is load-bearing in transformed_custom_view/controls —
// it selects the measure-dropdown filtering branch), different dataset.
export const ThreeForecastTrackingContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "three_forecast_tracking",
        transformId: "three_forecast_tracking",
        folder: "outputs",
        title: "Forecast Tracking",
        dateHierarchyColumnFilter: {
          order_delivery_month: "month",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          buy_forecast: "buy forecast",
          demand_forecast: "demand forecast",
          orders: "orders",
          delivered: "delivered",
          open: "open",
          buy_forecast_accuracy: "buy forecast accuracy",
          demand_forecast_accuracy: "demand forecast accuracy",
          projected_forecast_accuracy: "projected forecast accuracy",
          buy_forecast_bias: "buy forecast bias",
          demand_forecast_bias: "demand forecast bias",
          projected_forecast_bias: "projected forecast bias",
        },
        measureOptionsFromFilterKeys: true,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.DatePeriodPicker,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createForecastTrackingMatrix,
        chunkedMatrixTransformId: "three_forecast_tracking_matrix",
        excludeDetailRows: true,
        breakdownMeasures: ["delivered"],
        additionalMeasuresWithTotals: ["delivered", "open", "buy_forecast", "demand_forecast"],
        shadeHistory: true,
        plainDetailLabels: true,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
